import {Columns} from 'compob2b-table';
import {translations} from '../../../../environments/translations.ru';


export const DAM_PERSON_FORM: Columns[] = [
  {
    key: 'id',
    title: translations.serialNumber,
    placeholder: translations.serialNumber,
    searchEnabled: true,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: true,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
    width: '80%',
  },
  {
    key: 'syncUid',
    title: translations.syncUid,
    placeholder: translations.syncUid,
    searchEnabled: false,
    formly: true,
    type: 'input',
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    searchEnabled: false,
    formly: true,
    defaultValue: true,
    type: 'checkbox',
    required: true
  },
  {
    key: 'action',
    title: translations.action,
    placeholder: translations.action,
    searchEnabled: false,
    grid: true,
    type: 'input',
    required: true
  }
];
